import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { from, switchMap, catchError, of } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const firebaseApp = getApps().length === 0 ? initializeApp(environment.firebaseConfig) : getApp();
  const auth = getAuth(firebaseApp);
  const currentUser = auth.currentUser;

  // Only intercept requests to our backend
  if (!req.url.startsWith(environment.backendUrl)) {
    return next(req);
  }

  if (!currentUser) {
    console.warn('AuthInterceptor: No authenticated user found for request to:', req.url);
    return next(req);
  }

  console.log('AuthInterceptor: Attaching token for user:', currentUser.uid);
  return from(currentUser.getIdToken()).pipe(
    switchMap(token => {
      console.log('AuthInterceptor: Token obtained, length:', token.length);
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next(authReq);
    }),
    catchError(err => {
      console.error('Interceptor error fetching token:', err);
      return next(req);
    })
  );
};
